var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sui-tree',_vm._b({staticClass:"tree-grid brdG01 pd20",attrs:{"mutiple":""}},'sui-tree',_vm.fdpTreeData,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }